import { useBranding } from '@/hooks/useBranding';

export function CollapsedBrandMark() {
  const { brandName, logos } = useBranding();
  if (logos.icon !== null) {
    return <img src={logos.icon} alt={brandName} className="w-9 h-9 rounded-lg object-contain" />;
  }
  return (
    <span
      role="img"
      aria-label={brandName}
      className="w-9 h-9 rounded-lg bg-zooprimary text-zoowhite flex items-center justify-center font-extrabold text-base"
    >
      {brandName.trim().slice(0, 1).toUpperCase()}
    </span>
  );
}
